import { useEffect } from "react";
import Layout from "../utils/core/Layout";
import "./DeleteAccount.css";

const DeleteAccountPage = () => {

  useEffect(() => {
    if (window.location.hash === "#top") {
      const heading = document.querySelector(".policy-page");
      if (heading) {
        heading.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []);

  return (
    <Layout>
      <div className="policy-page">
        <h1 className="policy-title">Account & Data Deletion</h1>

        {/* Blue banner */}
        <div className="policy-banner">
          <p className="policy-banner-updated">
            <strong>Last Updated:</strong> 27/11/2025
          </p>
          <p className="policy-banner-text">
            HOW TO DELETE YOUR GONEET ACCOUNT AND DATA
          </p>
        </div>

        {/* Intro */}
        <section className="policy-section">
          <p>
            At <strong>goneet</strong>, we respect your privacy and your right to control
            your personal data. If you wish to delete your goneet account and all associated
            data, please follow one of the options below.
          </p>
        </section>

        {/* Option A */}
        <section className="policy-section">
            <h2>Option A: Delete Account by Logging In</h2>
            <p>
                If you have access to your GoNeet account, you can delete your account
                directly from the app or website by following the steps below:
            </p>

            <ul className="policy-list">
                <li className="policy-list-item">• Login to your goneet account</li>
                <li className="policy-list-item">• Go to <strong>Settings</strong></li>
                <li className="policy-list-item">
                • Open <strong>Account Settings</strong>
                </li>
                <li className="policy-list-item">
                • Select <strong>Delete Account</strong> and confirm
                </li>
            </ul>

            <a
                href="https://goneet.com/login"
                className="delete-btn"
            >
                Login to Delete Account
            </a>
        </section>


        {/* Option B */}
        <section className="policy-section">
          <h2>Option B: Request Deletion Without Login</h2>
          <p>
            If you are unable to log in to your account, you can submit a manual
            deletion request.
          </p>

          <ul className="policy-list">
            {/* <li className="policy-list-item">
              • Submit a request using our support form
            </li> */}
            <li className="policy-list-item">
              •  Email us directly with your registered email ID
            </li>
          </ul>

          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:support@goneet.com">
              support@goneet.com
            </a>
          </p>

          <p>
            Please include your registered email address and mention
            <strong> “Account Deletion Request”</strong> in the subject.
          </p>
        </section>

        {/* Data handling */}
        <section className="policy-section">
          <h2>What Happens After Deletion?</h2>
          <p>
            Once your request is verified:
          </p>

          <ul className="policy-list">
            <li className="policy-list-item">• Your account will be permanently deleted</li>
            <li className="policy-list-item">• All personal data will be erased from our systems</li>
            <li className="policy-list-item">
              • Some data may be retained temporarily if required by law or security purposes
            </li>
          </ul>

          <p>
            Account deletion is <strong>irreversible</strong>.
          </p>
        </section>

        {/* Contact */}
        <section className="policy-section">
          <h2>Need Help?</h2>
          <p>
            If you have any questions regarding account deletion or data privacy,
            please contact us.
          </p>
          <p><strong>Email:</strong> support@goneet.com</p>
        </section>
      </div>
    </Layout>
  );
};

export default DeleteAccountPage;
